import { useContext } from 'react';

import { FwPageContentStoreContext } from './FwPageContentStoreContext';

const useFwPageContentStore = () => useContext(FwPageContentStoreContext);

export { useFwPageContentStore };
